import type { IMessage, SendProps } from 'react-native-gifted-chat';

import { StyleSheet } from 'react-native';

import { Send } from 'react-native-gifted-chat';
import { YStack } from 'tamagui';

import { Icon, getTestProps } from '@south-street-app/atoms';
import { getSizeTokenValue } from '@south-street-app/theme';

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    height: getSizeTokenValue('$10'),
    justifyContent: 'center',
    width: getSizeTokenValue('$10'),
  },
});

const ChatSendButton = (props: SendProps<IMessage>) => (
  <Send {...props} containerStyle={styles.container}>
    <YStack
      accessibilityLabel={'Send'}
      alignItems={'center'}
      backgroundColor={'$mono900'}
      borderRadius={'$full'}
      height={'$10'}
      justifyContent={'center'}
      width={'$10'}
      {...getTestProps('customer-chat-send-cta')}
    >
      <Icon
        color={'$transparent'}
        iconName={'arrowUpIcon'}
        size={'$6'}
        strokeColor={'$mono100'}
        {...getTestProps('customer-chat-send-icon')}
      />
    </YStack>
  </Send>
);

export { ChatSendButton };
